import { useDispatch } from 'react-redux';
import { fetchCurrentUser } from '../../../../user/currentUserActions';
import { useEffect, useRef } from 'react';

import { TIMES } from '../../../../../common/utils/timeUtil';

const useBoardSearchMigrationStatusObserver = (isBoardSearchMigrationComplete: boolean) => {
    const dispatch = useDispatch();
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        // If the migration is complete, clear any existing timer
        if (isBoardSearchMigrationComplete) {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
            return;
        }

        // If the migration is not complete, start polling every 2 minutes
        timerRef.current = setInterval(() => {
            dispatch(fetchCurrentUser());
        }, TIMES.MINUTE * 2);

        // Clean up the timer when the component unmounts
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [isBoardSearchMigrationComplete]);
};

export default useBoardSearchMigrationStatusObserver;
